import {
  StylingLook,
  StylingLookProductWithStockPrice,
  StylingLookVariantWithStockPrice,
  StylingLookWithStockPrice,
} from "../../types/productTypes/stylingLookProduct";
import { StockPriceProduct } from "../../types/productTypes/stockProduct";

export const mergeStylingLooksWithStockPrice = (
  looks: StylingLook[],
  stockPriceData: StockPriceProduct[]
): StylingLookWithStockPrice[] => {
  return looks
    .map((look) => {
      const updatedProducts = look.products
        .map((product) => {
          const stockData = stockPriceData.find(
            (sp) => sp.productId === product.id
          );
          if (!stockData) return null;

          const updatedVariants = product.variants
            ?.map((productVariant) => {
              const stockVariant = stockData.variants?.find(
                (sv) => sv.id === productVariant.variantId
              );
              if (!stockVariant) return null;

              return {
                ...productVariant,
                ...stockVariant,
              };
            })
            .filter(Boolean) as StylingLookVariantWithStockPrice[];

          if (product.variants?.length && !updatedVariants?.length) return null;

          return {
            ...product,
            ...stockData,
            variants: updatedVariants as StylingLookVariantWithStockPrice[],
          };
        })
        .filter(Boolean);

      return {
        ...look,
        products: updatedProducts as StylingLookProductWithStockPrice[],
      };
    })
    .filter((look) => look.products.length > 0);
};
